import { ModalFooterProps } from "./types";

const ModalFooter: React.FC<ModalFooterProps> = (props: ModalFooterProps) => {
  const { children } = props;

  return (
    <div className="bg-slate-50 border-t border-slate-200 w-full flex-shrink-0">
      {children}
    </div>
  );
};

export default ModalFooter;
